import { CharacteristicGroup } from './CharacteristicGroup';
import { SurveyVersion } from './SurveyVersion';

export class SecondaryReportOrgUser {
    public id: number;
    public secondaryReport?: SecondaryReport;
    public secondaryReportID: number;
    public organizationID?: number;
    public userID?: number;
    public allAccess: boolean;
}

export class SecondaryReport {
    public id: number;
    public name: string;
    public characteristicGroups: CharacteristicGroup[];
    public surveyVersion: SurveyVersion;
    public surveyVersionID: number;
    public secondaryReportOrgUsers: SecondaryReportOrgUser[];
}


// WEBPACK FOOTER //
// ./src/models/SecondaryReport.tsx